/**
 * @generated SignedSource<<dfaf624313650388ef43af101607dc79>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type createStandaloneSiteDialogMarketplaceQuery$variables = Record<PropertyKey, never>;
export type createStandaloneSiteDialogMarketplaceQuery$data = {
  readonly marketplaceThemes: ReadonlyArray<{
    readonly marketplaceThemeID: number;
    readonly name: string;
  }>;
};
export type createStandaloneSiteDialogMarketplaceQuery = {
  response: createStandaloneSiteDialogMarketplaceQuery$data;
  variables: createStandaloneSiteDialogMarketplaceQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "marketplaceThemeID",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "createStandaloneSiteDialogMarketplaceQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MarketplaceThemeInfo",
        "kind": "LinkedField",
        "name": "marketplaceThemes",
        "plural": true,
        "selections": [
          (v0/*:: as any*/),
          (v1/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "createStandaloneSiteDialogMarketplaceQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MarketplaceThemeInfo",
        "kind": "LinkedField",
        "name": "marketplaceThemes",
        "plural": true,
        "selections": [
          (v0/*:: as any*/),
          (v1/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5ed5ac5eef522b72797f814a61b638f5",
    "id": null,
    "metadata": {},
    "name": "createStandaloneSiteDialogMarketplaceQuery",
    "operationKind": "query",
    "text": "query createStandaloneSiteDialogMarketplaceQuery {\n  marketplaceThemes {\n    marketplaceThemeID\n    name\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "f53c8a30120e37f12e663dea1d382d4d";

export default node;
